import React, { useState } from "react";

import { Image } from "@chakra-ui/react";
import { useSmallerThanQuery } from "../../../utils/hooks/MediaQueryHook";

type SmileyIconProps = {
	currentValue: number;
	smileyValue: number;
	isSelected: boolean;
	saveReview: (smileyValue: number) => void;
	src: string;
	alt: string;
};

const GRAY_FILTER = `invert(10%) sepia(50%) saturate(28%)
					 hue-rotate(325deg) brightness(100%) contrast(50%)`;

const SMALLER_SCREEN_PIXELS = 413;

const SmileyIcon = ({
	currentValue,
	smileyValue,
	isSelected,
	saveReview,
	src,
	alt,
}: SmileyIconProps) => {
	const [isHovering, setHovering] = useState(false);
	const isSmallerThan = useSmallerThanQuery(SMALLER_SCREEN_PIXELS);

	const getCorrectPath = () => {
		const path = `${process.env.PUBLIC_URL}/smileys/%s/${src}`;
		return path.replace(
			"%s",
			isHovering && !isSelected ? "hoverUpdated" : "defaultUpdated"
		);
	};

	return (
		<Image
			flex={isSmallerThan ? "0 0 23%" : "none"}
			alignSelf="left"
			justifySelf="left"
			h={{ base: "65px", sm: "75px", md: "100px" }}
			w={{ base: "65px", sm: "75px", md: "100px" }}
			src={getCorrectPath()}
			alt={alt}
			cursor="pointer"
			filter={
				currentValue === smileyValue || !isSelected ? "" : GRAY_FILTER
			}
			onClick={() => saveReview(smileyValue)}
			transition="ease-in-out 200ms"
			transform={isHovering ? "scale(1.05)" : ""}
			onMouseOver={() => setHovering(true)}
			onMouseLeave={() => setHovering(false)}
		/>
	);
};

export default SmileyIcon;
